import MessageCenter, { type MessageChannelConfig } from "@/pages/admin/messages/components/MessageCenter";

const config: MessageChannelConfig = {
  channel: "email",
  eyebrow: "Marketing",
  title: "Email",
  subtitle: "Confirmations, quotes, seasonal newsletters and follow-ups sent to guests, schools and corporates.",
  icon: "ri-mail-send-line",
  composeTitle: "Compose Email",
  recipientLabel: "Recipient email",
  recipientPlaceholder: "guest@example.com",
  subjectLabel: "Subject",
  subjectPlaceholder: "e.g. Your booking is confirmed",
};

export default function AdminEmail() {
  return <MessageCenter config={config} />;
}